/* tslint:disable:no-forward-ref max-file-line-count */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TimepickerConfig } from './timepicker.config';
import { TimepickerService } from './timepicker.shared.service';

@Component({
  selector: 'timepicker',
  template: `
   <axis-inner-timepicker [activeTime]="activeTime"
                      [arrowkeys]="arrowkeys"
                      [hourStep]="hourStep"
                      [minuteStep]="minuteStep"
                      [secondsStep]="secondsStep"
                      [showSpinners]="showSpinners"
                      [showMeridian]="showMeridian"
                      [showSeconds]="showSeconds"
                      [meridians]="meridians"
                      [min]="min"
                      [max]="max"
                      (selectionDone)='onSelect($event)'
                      (closeEvent)="oncloseEvent($event)">
    </axis-inner-timepicker>`,
  host: {
    class: 'axis-timepicker-container'
  }
})
export class TimepickerComponent implements OnInit {

  @Input() arrowkeys: boolean; // if false up/down arrowkeys inside hours,minutes,seconds will be disabled.
  @Input() hourStep: number;  // hours change step.
  @Input() minuteStep: number;  // minutes change step.
  @Input() secondsStep: number;  // seconds change step.

  @Input() showSpinners: boolean;  // if true spinner arrows above and below the inputs will be shown.
  @Input() showMeridian: boolean;
  @Input() showSeconds: boolean;

  @Input() meridians: string[];  // meridian labels based on locale.

  @Input() min: Date;   // minimum time user can select.
  @Input() max: Date;   // maximum time user can select.

  @Input()
  public get activeTime(): Date {
    return this._activeTime || this._now;
  }
  public set activeTime(value: Date) {
    this._activeTime = value;
  }

  @Output() public selectionDone: EventEmitter<any> = new EventEmitter<any>(undefined);
  @Output() public closeEvent: EventEmitter<any> = new EventEmitter<any>(undefined);

  private modelValue: any;
  protected _activeTime: any;
  protected _now: any = new Date();

  public onChange: any = Function.prototype;
  public onTouched: any = Function.prototype;

  // @HostBinding('class.axis-timepicker-container')
  // axisTimepickerContainer = true;

  constructor(
    _config: TimepickerConfig,
    private timePickerService: TimepickerService
  ) {
    Object.assign(
      this,
      _config,
      this.timePickerService.getTimepickerInstance()
    );
  }

  ngOnInit() {
    if (this.modelValue) {
      this.proxywriteValue(this.modelValue);
    }
  }

  onSelect(event: Date) {
    this.onChange(event);
    this.selectionDone.emit(event);
  }

  public oncloseEvent(event: Date): void {
    this.onChange(event);
    this.closeEvent.emit(event);
  }

  public proxywriteValue(value: any): void {
    this.activeTime = value ? new Date(value) : void 0;
  }
}
